import { useContext, useState } from "react";
import "./styles.scss";
import { Context } from "../../context/Contex";
import GeneralSection from "./GeneralSection";
import RoutesSection from "./RoutesSection";
import ColumnMappingSection from "./ColumnMappingSection";
import UsersSection from "./UsersSection";
import PermissionSection from "./PermissionSection";
import SecuritySection from "./SecuritySection";
import StatusConfigSection from "./StatusConfigSection";
import IgnoredStatusSection from "./IgnoredStatusSection";
import ServiceTypeFilterSection from "./ServiceTypeFilterSection";

export default function Section() {
    const [activeSection, setActiveSection] = useState("general");

    const { router } = useContext(Context);

    const menuItems = [
        { id: "general", icon: "⚙️", label: "Geral", component: <GeneralSection /> },
        // { id: "routes", icon: "🔒", label: "Rotas Protegidas", component: <RoutesSection router={router} /> },
        { id: "mapping", icon: "📋", label: "Mapeamento de Colunas", component: <ColumnMappingSection /> },
        { id: "status", icon: "🎨", label: "Status & Cores", component: <StatusConfigSection /> },
        { id: "ignored", icon: "🚫", label: "Status Ignorados", component: <IgnoredStatusSection /> },
        { id: "serviceTypes", icon: "🔍", label: "Tipos de Serviço", component: <ServiceTypeFilterSection /> },
        { id: "users", icon: "👥", label: "Usuários", component: <UsersSection /> },
        { id: "permission", icon: "🔑", label: "Permissões", component: <PermissionSection /> },
        { id: "security", icon: "🛡️", label: "Segurança", component: <SecuritySection /> },
    ];

    const activeComponent = menuItems.find(item => item.id === activeSection)?.component;

    return (
        <div className="config-container">
            <aside className="config-sidebar">
                <h2>Configurações Admin</h2>
                <nav className="config-nav">
                    {menuItems.map((item) => (
                        <button
                            key={item.id}
                            className={activeSection === item.id ? "active" : ""}
                            onClick={() => setActiveSection(item.id)}
                        >
                            <span className="icon">{item.icon}</span>
                            {item.label}
                        </button>
                    ))}
                </nav>
            </aside>

            <main className="config-content">
                {activeComponent}
            </main>
        </div>
    )
}